import { useState } from "react";
import { useLogin } from "../hooks/useLogin";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import logo from '/logo.svg';

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const login = useLogin();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    login.mutate(
      { email, password },
      {
        onSuccess: (data) => {
          localStorage.setItem("token", data.token);
          navigate("/dashboard");
        },
      }
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <Card className="w-full max-w-md shadow-lg! border-0 p-6 rounded-xl!">
        <div className="flex flex-col items-center mb-6">
          <img src={logo} alt="Logo" className="h-12 mb-2" />
          <h2 className="text-2xl font-semibold text-slate-800">Welcome Back</h2>
          <p className="text-slate-500">Sign in to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="font-medium text-slate-700">Email</label>
            <InputText
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="password" className="font-medium text-slate-700">Password</label>
            <Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              feedback={false}
              toggleMask
              placeholder="Enter your password"
              className="w-full [&>*]:w-full"
              inputClassName="w-full"
            />
          </div>

          {login.isError && (
            <div className="text-red-500 text-sm text-center bg-red-50 p-2 rounded">
              {login.error.message || "Login failed. Please check your credentials."}
            </div>
          )}

          <Button
            label={login.isPending ? "Signing in..." : "Sign In"}
            icon={login.isPending ? "pi pi-spin pi-spinner" : ""}
            type="submit"
            disabled={login.isPending}
            className="w-full mt-2"
          />
        </form>
      </Card>
    </div>
  );
}
